// src/Veemo_Semantic/Custom/VmoDeleteModal.js
import React from "react";
import PropTypes from "prop-types";
import VmoButton from "../Elements/VmoButton/VmoButton";
import VmoModal from "../Modules/Modal/VmoModal";
import VmoModalActions from "../Modules/Modal/VmoModalActions";
import VmoModalContent from "../Modules/Modal/VmoModalContent";
import VmoModalHeader from "../Modules/Modal/VmoModalHeader";
import VmoForm from "../Collections/VmoForm/VmoForm";
import VmoFormField from "../Collections/VmoForm/VmoFormField";
import VmoFormInput from "../Collections/VmoForm/VmoFormInput";

function VmoDeleteModal({
  open = false,
  onClose,
  onConfirm,
  isLoading = false,
  modalHeader = "Delete!!!",
  modalContent = "Are you sure you want to Delete?",
  confirmText = "Delete",
  isManual = false,
  confirmBtnColor = "red",
}) {
  const [inputText, setInputText] = React.useState("");
  if (!open) return null;

  return (
    <VmoModal
      closeIcon
      size="tiny"
      centered={false}
      open={Boolean(open)}
      onClose={onClose}
    >
      <VmoModalHeader>{modalHeader}</VmoModalHeader>
      <VmoModalContent>
        {!isManual && modalContent}
        {isManual && (
          <VmoForm>
            <VmoFormField>
              <label>
                To confirm, type "<b>DELETE</b>" in the text below
              </label>
              <VmoFormInput
                type="text"
                value={inputText}
                onChange={(e, { value }) => setInputText(value)}
              />
            </VmoFormField>
          </VmoForm>
        )}
      </VmoModalContent>
      <VmoModalActions>
        <VmoButton data-test-id="cancel-btn" basic onClick={onClose}>
          Cancel
        </VmoButton>
        <VmoButton
          disabled={isManual && inputText !== "DELETE"}
          data-test-id="delete-btn"
          loading={isLoading}
          color={confirmBtnColor}
          onClick={onConfirm}
        >
          {confirmText}
        </VmoButton>
      </VmoModalActions>
    </VmoModal>
  );
}

VmoDeleteModal.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  modalHeader: PropTypes.string,
  modalContent: PropTypes.string,
  confirmText: PropTypes.string,
  isManual: PropTypes.bool,
  confirmBtnColor: PropTypes.string,
};

export default VmoDeleteModal;
